module.exports = __webpack_public_path__ + "img/applestore-150x150.3d070e48.png";